module.exports = (__webpack_require__(0))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/UploadWidget.js from dll-reference girder_lib
// module id = 36
// module chunks = 0